import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
    TitleWrapper,
    TitleText,
    StyledButton,
} from "../../../shared/styled/TitleBar";
import AddIcon from "../../../shared/svg/AddIcon";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";

const Title = () => {
    const navigate = useNavigate();
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canCreate = [ROLE.MANAGER, ROLE.LOGISTIC_STAFF].includes(role);

    const onClickAddButton = () => {
        navigate("/providers/create");
    };

    return (
        <TitleWrapper>
            <TitleText>Danh sách nhà cung cấp</TitleText>
            {canCreate && (
                <StyledButton variant="contained" onClick={onClickAddButton}>
                    <AddIcon />
                    Tạo mới nhà cung cấp
                </StyledButton>
            )}
        </TitleWrapper>
    );
};

export default Title;
